import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ backgroundColor: '#FBF6EF' }}
      data-testid="landing-hero"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 md:py-24">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
          {/* Left — copy */}
          <div className="flex-1 max-w-xl">
            <h1
              className="text-4xl sm:text-5xl lg:text-[3.5rem] font-extrabold leading-tight tracking-tight"
              style={{ color: '#5B2D1F' }}
              data-testid="landing-hero-heading"
            >
              Understand how your medications work together.
            </h1>
            <p
              className="mt-5 text-lg leading-relaxed"
              style={{ color: '#6B4A3A' }}
            >
              AI-assisted drug interaction analysis, scheduled reminders, and one-tap
              doctor summaries&nbsp;&mdash; built for people managing multiple
              prescriptions and over-the-counter medications.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <Link
                to="/signup"
                data-testid="landing-hero-signup-btn"
                className="inline-flex items-center justify-center px-8 py-4 rounded-xl text-lg font-extrabold text-white transition-opacity hover:opacity-90"
                style={{ backgroundColor: '#D77A52' }}
              >
                Get started &mdash; it&rsquo;s free
              </Link>
              <Link
                to="/signin"
                data-testid="landing-hero-signin-btn"
                className="inline-flex items-center justify-center px-8 py-4 rounded-xl text-lg font-extrabold border-2 transition-opacity hover:opacity-90"
                style={{ borderColor: '#D77A52', color: '#D77A52' }}
              >
                I have an account
              </Link>
            </div>
            <p className="mt-4 text-sm" style={{ color: '#8B7A6B' }}>
              No credit card. No ads. Free during beta.
            </p>
          </div>

          {/* Right — illustration with overlaid logo */}
          <div className="flex-1 flex items-center justify-center relative max-w-lg w-full rounded-2xl overflow-hidden" style={{ backgroundColor: '#EDE4D6' }}>
            <img
              src="/brand/hero.png"
              alt="Southwestern landscape illustration with medication pills"
              className="w-full h-auto"
              loading="lazy"
              data-testid="landing-hero-illustration"
            />
            <img
              src="/brand/logo-round.png"
              alt="Heritage Compass logo"
              className="absolute w-20 h-20 sm:w-24 sm:h-24 rounded-full drop-shadow-lg"
              style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
              data-testid="landing-hero-logo-overlay"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
